import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import InputWithStyle from "../../HOCs/InputWithStyle/InputWithStyle";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { Paper } from "@material-ui/core";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const style = {
	div: { lineHeight: 3, fontWeight: 600, fontSize: "1.1em", marginBottom: "5px" },
	input: { width: 125, marginLeft: 10, backgroundColor: "white" },
};

const schema = yup.object().shape({
	pointsRequired: yup.number().moreThan(-1).integer().required(),
	minAmountToClaimReward: yup.number().moreThan(-1).integer().required(),
	// minPurchaseAmount: yup.number().moreThan(0).integer().required(),
});

const LoyaltyLevel = ({ label, onSubmit, defaultValues = {} }) => {
	const { register, handleSubmit, errors, setValue } = useForm({ defaultValues, resolver: yupResolver(schema) });

	useEffect(() => {
		if (defaultValues) {
			for (const [key, val] of Object.entries(defaultValues)) {
				setValue(key, val);
			}
		}
	}, [defaultValues, setValue]);

	return (
		<Paper
			elevation={3}
			style={{ backgroundColor: "#f9f9f9f9", border: "1px solid gray", maxWidth: "300px", margin: "auto" }}
		>
			<form onSubmit={handleSubmit(onSubmit)}>
				<h3>{label}</h3>
				<label>
					<div style={style.div}>
						Puntos para llegar a este nivel
						<InputWithStyle
							variant="outlined"
							inputRef={register}
							name="pointsRequired"
							style={style.input}
							type="number"
						/>
					</div>
					<p style={{ color: "red" }}>{errors.pointsRequired && "Debe ser número valido"}</p>
				</label>
				<label>
					<div style={style.div}>
						Monto mínimo para canjear un cupón
						<InputWithStyle
							variant="outlined"
							inputRef={register}
							name="minAmountToClaimReward"
							style={style.input}
							type="number"
						/>
					</div>
					<p>{errors.minAmountToClaimReward?.message}</p>
				</label>
				{/* <label>
					<div style={style.div}>
						Cantidad necesaria para sumar 1 punto
						<InputWithStyle
							variant="outlined"
							inputRef={register}
							name="minPurchaseAmount"
							style={style.input}
							type="number"
						/>
					</div>
					<p>{errors.minPurchaseAmount?.message}</p>
				</label> */}
				<ButtonWithStyle onClick={handleSubmit(onSubmit)}>Guardar</ButtonWithStyle>
			</form>
		</Paper>
	);
};

export default LoyaltyLevel;
